/* (2026-10-25) Product photos come on different backdrops (pure white, light grey 235-246, studio). A photo shown whole inside its
   frame ("contain") leaves space around it; this paints that space with the photo's own corner colour so every photo sits
   seamlessly in its card, whatever it was shot on. Photos are same-origin (/cdn/shop), so reading pixels is allowed.
   (2026-10-25, zoom) Garments shot flat with lots of empty backdrop (wide hoodies in square photos) looked small on phones: on a
   plain, even backdrop the script finds the garment and zooms the photo so the garment fills ~88% of its frame. Only empty
   backdrop is trimmed — never the garment — and it never zooms past 1.8x. Photos with busy backgrounds (models, scenes) are left
   exactly as they are. If anything fails the photo simply stays as before. */
(function () {
  var sel = '.card .img img.contain, .gallery .g img.contain, .inc-row img, .colors a img';
  var zoomSel = '.card .img img.contain, .gallery .g img.contain';
  var FILL = 0.88, MAXZ = 1.8, N = 96;
  var cv = document.createElement('canvas');
  var cx = cv.getContext && cv.getContext('2d', { willReadFrequently: true });
  function measure(img) {
    var w = img.naturalWidth, h = img.naturalHeight; if (!w || !h) return null;
    var sw = Math.max(1, Math.round(w > h ? N : N * w / h)), sh = Math.max(1, Math.round(h >= w ? N : N * h / w));
    cv.width = sw; cv.height = sh; cx.clearRect(0, 0, sw, sh); cx.drawImage(img, 0, 0, sw, sh);
    var d = cx.getImageData(0, 0, sw, sh).data, i, x, y;
    var corners = [[1, 1], [sw - 2, 1], [1, sh - 2], [sw - 2, sh - 2]], bg = [0, 0, 0];
    for (i = 0; i < 4; i++) { var o = (corners[i][1] * sw + corners[i][0]) * 4; bg[0] += d[o] / 4; bg[1] += d[o + 1] / 4; bg[2] += d[o + 2] / 4; }
    var spread = 0; for (i = 0; i < 4; i++) { var q = (corners[i][1] * sw + corners[i][0]) * 4; spread = Math.max(spread, Math.abs(d[q] - bg[0]) + Math.abs(d[q + 1] - bg[1]) + Math.abs(d[q + 2] - bg[2])); }
    var box = null;
    if (spread < 24) {                                   // even backdrop only
      var l = sw, t = sh, r = -1, b = -1, edge = 0;
      for (y = 0; y < sh; y++) for (x = 0; x < sw; x++) {
        var p = (y * sw + x) * 4;
        if (Math.abs(d[p] - bg[0]) + Math.abs(d[p + 1] - bg[1]) + Math.abs(d[p + 2] - bg[2]) > 60) {
          if (x < l) l = x; if (x > r) r = x; if (y < t) t = y; if (y > b) b = y;
          if (x === 0 || y === 0 || x === sw - 1 || y === sh - 1) edge++;
        }
      }
      if (r > l && b > t && edge < 3 && (r - l) > sw * 0.15 && (b - t) > sh * 0.15) box = { l: l / sw, t: t / sh, r: (r + 1) / sw, b: (b + 1) / sh };
    }
    return { bg: 'rgb(' + Math.round(bg[0]) + ',' + Math.round(bg[1]) + ',' + Math.round(bg[2]) + ')', box: box };
  }
  function zoom(img, box) {
    var frame = img.parentElement; if (!frame) return;
    var W = frame.clientWidth, H = frame.clientHeight; if (!W || !H) return;
    var iw = img.naturalWidth, ih = img.naturalHeight, k = Math.min(W / iw, H / ih);
    var rw = iw * k, rh = ih * k, ox = (W - rw) / 2, oy = (H - rh) / 2;     // the photo shown whole (contain, no margin)
    var gl = ox + box.l * rw, gt = oy + box.t * rh, gw = (box.r - box.l) * rw, gh = (box.b - box.t) * rh;
    var z = Math.min(FILL * W / gw, FILL * H / gh, MAXZ);
    if (z <= 1.02) { img.style.padding = '0'; return; }
    var gcx = gl + gw / 2, gcy = gt + gh / 2;
    img.style.padding = '0';
    img.style.transformOrigin = gcx + 'px ' + gcy + 'px';
    img.style.transform = 'translate(' + (W / 2 - gcx) + 'px,' + (H / 2 - gcy) + 'px) scale(' + z.toFixed(3) + ')';
    frame.style.overflow = 'hidden';
    img.dataset.zoom = z.toFixed(2);
  }
  function paint(img) {
    if (!cx || img.dataset.bg) return;
    try {
      var m = measure(img); if (!m) return;
      img.style.backgroundColor = m.bg;
      if (img.parentElement) img.parentElement.style.backgroundColor = m.bg;
      img.dataset.bg = '1';
      if (m.box && img.matches(zoomSel)) { img._box = m.box; zoom(img, m.box); }
    } catch (e) { img.dataset.bg = 'x'; }
  }
  function run() {
    var list = document.querySelectorAll(sel);
    for (var i = 0; i < list.length; i++) {
      var img = list[i];
      if (img.complete && img.naturalWidth) paint(img);
      else img.addEventListener('load', function (e) { paint(e.target); }, { once: true });
    }
  }
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () {
    var z = document.querySelectorAll('img[data-zoom]'); for (var i = 0; i < z.length; i++) if (z[i]._box) zoom(z[i], z[i]._box);
  }, 150); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
